// extracted by mini-css-extract-plugin
export var downArrow = "_71-0";
export var label = "_71-1";
export var treatmentCard = "_71-3";
export var upArrow = "_71-2";